import { PATHS, type NavItem } from '@ctcells/core'

/**
 * 태블릿 kiosk 에 싣는 화면 — **콘솔 12종 중 3종**.
 *
 * ⚠ **와이어프레임에도 정본에도 목록이 없다.** 태블릿은 「콘솔의 축약형」이라고만 되어 있고
 *   무엇을 축약하는지가 정해져 있지 않다. eric 이 자리를 비워 화면 작업자가 정했고,
 *   근거와 되돌리는 법은 `docs/screens-pad.md` 에 적었다.
 *
 * 고른 기준은 **현장에서 서서 하는 일**이다 — 보고(모니터링) · 지금 작업 확인(작업) ·
 * 조치(알람). 확약·E-STOP 은 이미 상시 작업 줄에 있어 화면을 더 싣지 않아도 된다.
 *
 * 🔴 **개발 › 제어(수동 조작)는 싣지 않는다.** kiosk 는 물리 접근 통제가 약한 자리다
 *    (`08 §9.2` 의 「노출 경계·물리 접근 통제」 미결과 같은 이유).
 * 🔸 등록·편집 계열(시료 · 레시피 · 랩웨어 · 관리 · 로그 · 모듈 · 이력)은 뺐다.
 *    표 편집이 주된 화면이라 12인치 터치에서 쓸 수 없다.
 *
 * 목록을 바꾸려면 이 배열 하나만 고치면 된다 — 라우트도 내비도 여기서 나온다.
 */
export const TABLET_NAV: readonly NavItem[] = [
  {
    id: 'monitoring',
    path: `${PATHS.tablet}/monitoring`,
    labelKey: 'nav.item.monitoring',
    permission: 'monitor',
  },
  {
    id: 'batches',
    path: `${PATHS.tablet}/batches`,
    labelKey: 'nav.item.batches',
    permission: 'view',
  },
  {
    id: 'alarms',
    path: `${PATHS.tablet}/alarms`,
    labelKey: 'nav.item.alarms',
    permission: 'monitor',
  },
]

/** 태블릿 기본 화면. 첫 항목이 곧 기본값이다 — 목록을 바꿔도 따라온다 */
export const TABLET_HOME_PATH: string = TABLET_NAV[0]?.path ?? PATHS.tablet

/**
 * 태블릿 안에서만 쓰는 경로 표(`id` → 경로). 위 목록이 유일한 출처다.
 *
 * 🔴 **`PATHS` 를 태블릿에서 그대로 쓰면 kiosk 밖으로 튕긴다** — 콘솔은 `/batches` 이고
 *    여기는 `/tablet/batches` 다. 셸(`TabletLayout`)과 어댑터(`tabletViews.tsx`)가 **같은
 *    표**를 봐야 작업 줄과 화면이 같은 곳으로 간다.
 * ⚠ **없는 키는 `undefined` 다.** 태블릿에 **레시피 상세가 없어서** `recipes` 가 그렇다 —
 *   그 자리는 이동을 안 넘기고, 작업 줄이 글자로 그린다(죽은 버튼 금지).
 */
export const TABLET_PATH: Readonly<Record<string, string | undefined>> = Object.fromEntries(
  TABLET_NAV.map((item) => [item.id, item.path]),
)
